export default "__VITE_ASSET__37639a8b__"